import { render } from "./ApproveOrderModal.vue?vue&type=template&id=023a6a81&scoped=true"
import script from "./ApproveOrderModal.vue?vue&type=script&lang=js"
export * from "./ApproveOrderModal.vue?vue&type=script&lang=js"

import "./ApproveOrderModal.vue?vue&type=style&index=0&id=023a6a81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023a6a81"]])

export default __exports__